"use strict";

import angular from "angular";
import template from "./app.component.html";
import "./app.component.scss";
import { LocalStoreService } from "./presentation/services/LocalStoreService";

export class AppComponent {
    constructor($transitions) {
        this.$transitions = $transitions;
        this.LocalStoreService = new LocalStoreService();
        this.LocalStoreService.setItem("accounting", {});
        this.LocalStoreService.setItem("company", {});
    }
    $onInit() {
        this._stateBodyClassWatcher();
    }
    _stateBodyClassWatcher() {
        this.$transitions.onFinish({}, (transition) => {
            const from = transition.from();
            const to = transition.to();
            angular.element(document.body).removeClass(from.bodyClass);
            if (to.bodyClass)
                angular.element(document.body).addClass(to.bodyClass);
        });
    }
}

AppComponent.$inject = ["$transitions"];

const name = "appRoot";
const def = {
    controller: AppComponent,
    bindings: {},
    template
};

angular.module("nucont").component(name, def);
export default { name, ...def };
